import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
  fileUlpload: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    '& label': {
      height: '75px !important',
      width: '500px',
    },
  },
  loading: {
    position: 'absolute',
    right: '-32px',
  },
  root: {
    minHeight: '100px',
  },
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: '10px',
      overflowY: 'inherit',
    },
    '& .MuiDialogContent-root': {
      overflowY: 'auto',
      '&::scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-moz-scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar-thumb': {
        width: '0',
        minWidth: '0',
      },
      '&.noneOverFlow': {
        overflowY: 'inherit',
      },
    },
    '& .MuiDialogActions-root': {
      justifyContent: 'flex-start',
      display: 'flex',
      flexDirection: 'row-reverse',
      padding: '20px',
      gap: '15px',
    },
    '& .MuiDialog-container': {
      width: '100vw',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
  },
  title: {
    margin: 0,
    padding: '20px',
    borderBottom: '1px solid #E2E5E9',

    '& h2': {
      fontSize: 16,
      color: '#0C0E10',
    },
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  cancelButton: {
    marginLeft: '5px',
  },
  addButton: {
    [theme.breakpoints.up('md')]: {
      transform: 'translate(5px, 31px)',
    },
  },
  fileUpload: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '24px',
  },
  fileLink: {
    width: '50%',
    display: 'flex',
    margin: '12px 0',
  },
  containerFileUpload: {
    display: 'flex',
    'flex-wrap': 'wrap',
  },
  contentFile: {
    height: '200px !important',
    'overflow-y': 'auto',
    marginLeft: '32px !important',
  },
  selectedFileDescription: {
    display: 'flex',
    marginTop: '4px',
    alignItems: 'center',
    justifyContent: 'space-around',
    backgroundColor: '#D9E8FF',
    padding: '12px 4px',
    '& p': {},
  },
  noFile: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export const useStylesTagingDialog = makeStyles((theme) => ({
  dialogMain: {
    '& .MuiDialog-paper': {
      borderRadius: '10px',
      overflowY: 'inherit',
    },
    '& .MuiDialogContent-root': {
      overflowY: 'auto',
      '&::scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-moz-scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar-thumb': {
        width: '0',
        minWidth: '0',
      },
      '&.noneOverFlow': {
        overflowY: 'inherit',
      },
    },
    '& .MuiDialogActions-root': {
      justifyContent: 'flex-start',
      display: 'flex',
      flexDirection: 'row-reverse',
      padding: '20px',
      gap: '15px',
    },
    '& .MuiDialog-container': {
      width: '100vw',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
  },
  title: {
    margin: 0,
    padding: '20px',
    borderBottom: '1px solid #E2E5E9',

    '& h2': {
      fontSize: 16,
      color: '#0C0E10',
    },
  },
  dialog: {
    textAlign: 'left',
    direction: 'ltr',
    padding: theme.spacing(2),
    lineHeight: 2,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  cancelButton: {
    marginLeft: '5px',
  },
  addButton: {
    [theme.breakpoints.up('md')]: {
      transform: 'translate(5px, 31px)',
    },
  },
}));
